import { useMemo } from "react";
import { usePriceList } from "@/react/Webshop/providers/PriceListProvider";
function usePriceListProductByUuid(uuid) {
    const { getProductByUuid } = usePriceList();
    return useMemo(() => {
        return getProductByUuid(uuid);
    }, [uuid, getProductByUuid]);
}
export default usePriceListProductByUuid;
